import { render, staticRenderFns } from "./CustomerBalancePrintReport.vue?vue&type=template&id=196b072f&"
import script from "./CustomerBalancePrintReport.vue?vue&type=script&lang=js&"
export * from "./CustomerBalancePrintReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports